import { PageInfo } from "@/components/Pagination";
import { TypedDocumentNode, gql } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import type { OrderPaymentStatus, OrderStage } from "@/pages/billing/types";

type PersonBillingOrderNode = {
  id: string;
  status: OrderStage;
  paymentStatus: OrderPaymentStatus | null;
  balance: number;
  dueDate?: string | null;
  payable: boolean;
  updatedAt: string;
  description: string;
  person: {
    id: string;
    firstName: string;
    lastName: string;
  };
  lineItems: {
    id: string;
    name: string;
    quantity: number;
    priceCents: number;
    totalPrice: number;
  }[];
};

type PersonBillingOrdersQuery = {
  commerceOrders: {
    totalCount: number;
    nodes: PersonBillingOrderNode[];
    pageInfo: PageInfo;
  };
};

type PersonBillingOrdersVariables = {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  query?: string;
  statuses?: string[];
};

export const PERSON_BILLING_ORDERS_QUERY: TypedDocumentNode<PersonBillingOrdersQuery, PersonBillingOrdersVariables> =
  gql`
    query GetPersonBillingOrders(
      $first: Int
      $last: Int
      $after: String
      $before: String
      $query: String
      $statuses: [String!]
    ) {
      commerceOrders(
        first: $first
        last: $last
        after: $after
        before: $before
        filters: { search: $query, status: $statuses }
      ) {
        nodes {
          id
          status
          paymentStatus
          balance
          dueDate
          payable
          updatedAt
          description
          person {
            id
            firstName
            lastName
          }
          lineItems {
            id
            name
            quantity
            priceCents
            totalPrice
          }
        }
        ...PageInfo
      }
    }

    ${PAGE_INFO_FRAGMENT}
  `;
